import { useEffect, useRef, useState } from "react";
import { MEETING_OPEN_RETRY_MAX_MS } from "../Constants/constantValues";

const useRetryWhenMeetingOpens = (onOpen) => {
  const [opensAt, setOpensAt] = useState(null);
  const onOpenRef = useRef(onOpen);
  onOpenRef.current = onOpen;

  useEffect(() => {
    if (!opensAt) return;

    const delay = Math.min(Math.max(new Date(opensAt) - Date.now(), 0) + 1000, MEETING_OPEN_RETRY_MAX_MS);
    const timer = setTimeout(() => {
      setOpensAt(null);
      onOpenRef.current();
    }, delay);
    return () => clearTimeout(timer);
  }, [opensAt]);

  return [opensAt, setOpensAt];
};

export default useRetryWhenMeetingOpens;
